export const DIVERGENCE_FIELD = [
99,104,97,105,114,64,99,118,111,110,108,105,110,101,57,56,55,54
];